import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'

const fnsResponsesSearchSchema = z.object({
  mode: z.enum(['survey', 'form']).optional(),
  id: z.string().optional(),
  name: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/fns-responses/')({
  validateSearch: fnsResponsesSearchSchema,
})
